import { defineStore } from "pinia";
import { APP_BASE, API_BASE } from "@/shared/config/constants";
import { getCurrentUser, logout as logoutRequest } from "@/services/api/tokenomics";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    loaded: false,
    loading: false,
  }),
  getters: {
    isAuthenticated: (state) => Boolean(state.user),
    accountLabel: (state) => state.user?.displayName || state.user?.email || state.user?.phone || "小能熊用户",
  },
  actions: {
    loginUrl(redirect = APP_BASE) {
      return `${API_BASE}/auth/login?redirect=${encodeURIComponent(redirect)}`;
    },
    async loadAuth() {
      this.loading = true;
      try {
        const data = await getCurrentUser();
        this.user = data?.user ?? null;
        return this.user;
      } catch {
        this.user = null;
        return null;
      } finally {
        this.loaded = true;
        this.loading = false;
      }
    },
    async logout() {
      await logoutRequest();
      this.user = null;
      window.location.href = APP_BASE;
    },
  },
});
